import type { SnowflakeTableFqn } from 'app/lib/types/server';
import { toStringFqn } from 'app/lib/utils';

export const findViewBySpaceAndFqn = (
    entities: { spaceUid: string; tableFqn: SnowflakeTableFqn }[],
    spaceUid: string,
    fqn: string
) =>
    Object.values(entities).find(
        (entity) => entity.spaceUid === spaceUid && toStringFqn(entity.tableFqn) === fqn
    );
